import { defineMessages } from "react-intl";

export default defineMessages({
  creditCard: {
    id: "paymentMethods.creditCard",
    defaultMessage: "Credit Card",
  },
  noCreditCard: {
    id: "paymentMethods.noCreditCard",
    defaultMessage: "No credit card",
  },
  creditCardTransactionsAreNotSupportedForThisService: {
    id: "paymentMethods.creditCardTransactionsAreNotSupportedForThisService",
    defaultMessage:
      "Credit card transactions are not supported for this service",
  },
});
